var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFloatArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7126 12L16 13.88L21.5628 20L16 26.12L17.7126 28L25 20L17.7126 12Z",
    fill: "#C9CBD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloatArrow);
export default __webpack_public_path__ + "static/media/icon_float_arrow.c998e03694cc00e364703fd333a2ca35.svg";
export { ForwardRef as ReactComponent };